import { IMAGE_TYPE, VIDEO_TYPE, AUDIO_TYPE, FILE_UPLOAD_TYPE, GALLERY_TYPE } from 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const GALLERY_FILE_TYPES = { IMAGE: "image", VIDEO: "video" };
const galleryItemBuilder = {
  [GALLERY_FILE_TYPES.IMAGE]: (img, preloadImage) => {
    return {
      metadata: { type: GALLERY_FILE_TYPES.IMAGE, height: img.height, width: img.width },
      url: preloadImage ? img.src : img.file_name,
      tempData: preloadImage
    };
  },
  [GALLERY_FILE_TYPES.VIDEO]: (video, preloadImage) => {
    const {
      thumbnail: { pathname, width, height }
    } = video;
    return {
      metadata: {
        type: GALLERY_FILE_TYPES.VIDEO,
        height: video.height || height,
        width: video.width || width,
        poster: { url: pathname, width, height }
      },
      url: video.pathname,
      tempData: preloadImage
    };
  }
};
const setItemInGallery = (item, componentData, itemPos) => {
  let { items, styles } = componentData;
  if (typeof itemPos === "undefined") {
    items = [...items, item];
  } else {
    items = [...items];
    items[itemPos] = item;
  }
  return { items, styles, config: {} };
};
const dataBuilder = {
  [IMAGE_TYPE]: ({ data, error }, componentData) => {
    const imageData = (data == null ? void 0 : data.length) ? data[0] : data;
    const config = __spreadValues({}, componentData.config);
    if (!config.alignment) {
      config.alignment = imageData.width >= 740 ? "center" : "left";
    }
    return __spreadProps(__spreadValues({}, componentData), { config, src: imageData, error });
  },
  [VIDEO_TYPE]: ({ data, error }, componentData) => {
    let { src } = componentData;
    if (data) {
      const { pathname, thumbnail, url } = data;
      src = pathname ? { pathname, thumbnail } : url;
    }
    return __spreadProps(__spreadValues({}, componentData), { src, error, tempData: void 0 });
  },
  [AUDIO_TYPE]: ({ data, error }, componentData) => {
    var _b, _c;
    const _a = componentData, rest = __objRest(_a, ["html", "tempData"]);
    const name = (_b = data == null ? void 0 : data.name) != null ? _b : componentData == null ? void 0 : componentData.name;
    const authorName = (_c = data == null ? void 0 : data.authorName) != null ? _c : componentData == null ? void 0 : componentData.authorName;
    const isCoverImageData = data == null ? void 0 : data.file_name;
    return isCoverImageData ? __spreadProps(__spreadValues({}, componentData), { coverImage: data }) : __spreadProps(__spreadValues({}, rest), {
      audio: data == null ? void 0 : data.audio,
      error,
      name,
      authorName
    });
  },
  [FILE_UPLOAD_TYPE]: ({ data, error }, componentData) => {
    return __spreadProps(__spreadValues(__spreadValues({}, componentData), data), { error, tempData: void 0 });
  },
  [GALLERY_TYPE]: ({ data, error }, componentData, fileType, itemIndex) => {
    var _a;
    const type = fileType || data.type || (data.thumbnail ? GALLERY_FILE_TYPES.VIDEO : GALLERY_FILE_TYPES.IMAGE);
    return setItemInGallery(
      __spreadProps(__spreadValues({}, (_a = galleryItemBuilder[type]) == null ? void 0 : _a.call(galleryItemBuilder, data)), { error }),
      componentData,
      itemIndex
    );
  }
};
const tempDataBuilder = {
  [IMAGE_TYPE]: ({ url }) => {
    return { dataUrl: url };
  },
  [VIDEO_TYPE]: ({ url }) => {
    return { src: url, tempData: true };
  },
  [AUDIO_TYPE]: ({ url, file }) => {
    if (!file.type.includes("image")) {
      const audio = { src: { id: url } };
      const name = file.name.split(".")[0];
      return { audio, name, tempData: true };
    }
  },
  [FILE_UPLOAD_TYPE]: ({ file }) => {
    const { name, size } = file;
    const type = name.split(".").pop();
    return { name, size, type, tempData: true };
  }
};
const uploadFunctionGetter = {
  [IMAGE_TYPE]: (props) => {
    var _a;
    return (_a = props.helpers) == null ? void 0 : _a.handleFileUpload;
  },
  [VIDEO_TYPE]: (props) => props.handleFileUpload,
  [AUDIO_TYPE]: (props) => props.handleFileUpload,
  [FILE_UPLOAD_TYPE]: (props) => {
    var _a;
    return (_a = props.settings) == null ? void 0 : _a.onFileSelected;
  },
  [GALLERY_TYPE]: (props) => {
    var _a;
    return (_a = props.helpers) == null ? void 0 : _a.handleFileUpload;
  }
};

export { GALLERY_FILE_TYPES, dataBuilder, tempDataBuilder, uploadFunctionGetter };
//# sourceMappingURL=mediaPluginsDataBuilders.js.map
